module.exports = "/layout/app/images/bg-header-gray.2940df9a.svg";